import { PROJECT_DISCUSSION_VIEW, PROJECT_BLOCKERS_VIEW } from '@/ability';
export { PROJECT_DISCUSSION_VIEW, PROJECT_BLOCKERS_VIEW };

// Socket events (project room)
export const DISCUSSION_SOCKET_EVENTS = {
    PROJECT_NEW: 'project:discussion:new',
    PROJECT_UPDATED: 'project:discussion:updated',
    PROJECT_DELETED: 'project:discussion:deleted',

    TASK_BLOCKER_NEW: 'project:task_blocker:discussion:new',
    TASK_BLOCKER_UPDATED: 'project:task_blocker:discussion:updated',
    TASK_BLOCKER_DELETED: 'project:task_blocker:discussion:deleted',

    BLOCKER_NEW: 'project:blocker:discussion:new',
    BLOCKER_UPDATED: 'project:blocker:discussion:updated',
    BLOCKER_DELETED: 'project:blocker:discussion:deleted',

    BUG_NEW: 'project:bug:discussion:new',
    BUG_UPDATED: 'project:bug:discussion:updated',
    BUG_DELETED: 'project:bug:discussion:deleted',
};

